import { formatPhoneNumber } from '@ztechapps/common.utils'
import type { CountryCode } from 'libphonenumber-js/max'

export type PhoneNumberDisplayProps = {
  value: string
  countryCode?: CountryCode
}

export const PhoneNumberDisplay = ({ countryCode, ...props }: PhoneNumberDisplayProps) => {
  const customCode = countryCode ?? 'US'

  // formatPhoneNumber returns null for a number it cannot format; show it as stored, not empty.
  return formatPhoneNumber(props.value, customCode) || props.value
}
